import { cn } from "@omni/utils/styles";

import { Col } from "@/components/General/Grid/col.component";
import { Row } from "@/components/General/Grid/row.component";
import { translateWithoutContext } from "@/redux/modules/value/translations/translations.helpers";

type TotalsRowComponentProps = {
    label: string;
    value: string;
    isTotalPrice?: boolean;
};

const TotalsRowComponent = ({
    label,
    value,
    isTotalPrice = false
}: TotalsRowComponentProps) => (
    <Row
        data-test={`shoppingCartSummary-${label.split(".").pop()}-price`}
        className={cn({
            "tw:text-sm tw:font-light tw:border-b tw:border-grey-light":
                !isTotalPrice,
            "tw:text-lg tw:font-bold": isTotalPrice
        })}
    >
        <Col
            xs={{ size: 5, offset: 3 }}
            className={cn("tw:p-2")}
        >
            {translateWithoutContext(label)}
        </Col>
        <Col
            xs={4}
            className={cn("tw:text-right tw:py-2")}
        >
            {value}
        </Col>
    </Row>
);

export default TotalsRowComponent;
